import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  convertToGetSearchQueryString,
  convertToPostSearchBody,
  SearchBody,
  SearchResult,
} from '@assess/shared/data-mart-search';

import { DataMartApiConfiguration } from './../data-mart-api-configuration';

@Injectable({ providedIn: 'root' })
export class SearchService {
  constructor(
    private readonly http: HttpClient,
    private readonly config: DataMartApiConfiguration
  ) {}

  search<TRecord = any>(resourceType: string, body?: Partial<SearchBody>) {
    return this.http.post<SearchResult<TRecord>>(
      `${this.config.rootUrl}/search/${resourceType}`,
      convertToPostSearchBody(body)
    );
  }

  searchHttpGet<TRecord = any>(resourceType: string, body: Partial<SearchBody>) {
    return this.http.get<SearchResult<TRecord>>(
      `${this.config.rootUrl}/search/${resourceType}?${convertToGetSearchQueryString(body)}`
    );
  }
}
